import rgbHex from 'rgb-hex'
import colors from '../../../config/colors.json'

function getXPProgress(totalXP) {
	let levelRequirements = [500, 1000, 2500]

	for (let i = 0; i < levelRequirements.length; i++) {
		if (totalXP < levelRequirements[i]) {
			const prevReq = i === 0 ? 0 : levelRequirements[i - 1]
			const nextReq = levelRequirements[i]
			return ((totalXP - prevReq) / (nextReq - prevReq)) * 100
		}
	}
	// If XP exceeds last requirement = max level
	return -1
}

export function JeanneXPBar({ xp, data, color, icon }) {
	//jeannes xp is just an integer an has no limits
	//all the level ups are just statemodel bools

	let mainColor = rgbHex(colors[color]?.mainColor)

	return (
		<div
			className={`border-solid border flex flex-col justify-center w-[84px] h-[40px]`}
			style={{
				borderColor: 'var(--main-color)',
				backgroundImage: 'url("/sheepCounter/background.png")',
			}}
		>
			<div className="flex flex-row w-[82px] justify-center">
				<img
					src="/liveGameIcons/unique/jd/button_flourish.png"
					className="aspect-auto w-[82px] h-[31px]"
					alt=""
				/>
				<img src={icon} className="absolute w-[33px] h-[33px]" alt="" />
			</div>
			<div className="w-[82px] h-[8px] flex flex-row border-solid border border-[#5E6989]">
				<div
					style={{
						backgroundColor: `#${mainColor}`,
						flexBasis: `${getXPProgress(xp)}%`,
					}}
				></div>
				<div
					style={{
						backgroundColor: '#000000',
						flexBasis: `${100 - getXPProgress(xp)}%`,
					}}
				></div>
			</div>
		</div>
	)
}
